import React, { useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import { useRouter } from 'next/router';
import { supabase_public } from '../../lib/supabaseClient';
import posthog from 'posthog-js';


const API_URL = process.env.NEXT_PUBLIC_API_URL;


function CreateAccount() {

//   const navigate = useNavigate(); // Call useNavigate inside the component
  const grad_color = {
    background: "linear-gradient(90deg, #007CF0 0%, #32B7E4 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    // textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
  };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [session, setSession] = useState('')

  const router = useRouter();
  const { isShopify, shop_domain } = router.query;
  let signInUrl = "/accounts/signin";
  if (isShopify && shop_domain) {
    signInUrl += `?isShopify=${isShopify}&shop_domain=${shop_domain}`;
  }

  const handleGoogleLogin = async () => {
    // Construct the base redirect URL
    let redirectUrl = `${window.location.origin}/accounts/signin`;

    // Append Shopify parameters if they are present
    if (isShopify && shop_domain) {
      redirectUrl += `?isShopify=${isShopify}&shop_domain=${shop_domain}&addShopify=true`;
    }

    try {
      const { data, error } = await supabase_public.auth.signInWithOAuth({
        provider: 'google',
        options: { redirectTo: redirectUrl }
      });

      console.log(data);
      if (error) {
        console.error('Error signing in with Google:', error.message);
        setErr(error.message);
      } else {
        // Additional logic after successful login (if needed)
        console.log("Google oauth success");
      }
    } catch (error) {
      console.error('Exception during Google sign in:', error);
      setErr(error.message);
    }
  };


  async function addtoShopify(id) {
    // If isShopify is true and shop_domain is present, send a POST request to /addShopifyUser
    if (isShopify && shop_domain && id) {
        const response = await fetch(API_URL + '/addShopifyUser', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            uid: id,
            shopify_domain: shop_domain,
        }),
        });
        // Handle the response from the POST request as needed
        if (!response.ok) {
        // Handle error
          console.error('Error adding Shopify user:', await response.text());
        } else {
          console.log("Added shopify user to db")
        }

    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 7) {
        setErr("Your password is less than 7 characters")
        return;

    }
    // Construct the redirect URL
    let emailRedirectUrl = process.env.NEXT_PUBLIC_FRONTEND_URL + 'accounts/signin';

    if (isShopify && shop_domain) {
        emailRedirectUrl += `?isShopify=${isShopify}&shop_domain=${shop_domain}`;
    }
    const { data, error } = await supabase_public.auth.signUp({
        email: email,
        password: password,
        options: {
            emailRedirectTo: emailRedirectUrl
        }
    });
    if (error) {
        console.error('Error signing up:', error.message);
        setErr("There are too many concurrent sign ups. Please try again later.")
    } else {
        posthog.capture('account created' , { 'email': email })

        await addtoShopify(data.user.id)

        router.push(`/accounts/emailconfirmation?email=${email}`); // Tell them to check email
    }

  }

  return (
        <>
        <div className="bg-grad-background bg-no-repeat bg-cover bg-center font-gilroy-regular">
            <div className="flex justify-center items-center h-screen">
            <div className=" bg-white p-6 rounded-lg shadow-lg w-500 md:w-[400px]">
                <img src="/logo-circle.png" className="h-16 sm:h-16 self-center mx-auto" alt="Claros Logo" />
                <h2 className="text-2xl text-center font-bold mt-4 mb-6 text-bluelogo font-gilroy"> Sign Up </h2>


                <form  onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">Email:</label>
                    <input type="email" id="email" name="email" className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-bluelogo font-gilroy-regular" placeholder="Enter your email" onChange={e => setEmail(e.target.value)} />
                </div>
                <div className="mb-4">
                    <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">Password:</label>
                    <input type="password" id="password" name="password" className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-bluelogo font-gilroy-regular" placeholder="Enter your password" onChange={e => setPassword(e.target.value)} />
                </div>
                <div className="mb-6 text-sm">
                 Already have an account? <a href={signInUrl} className="text-bluelogo"> Sign In </a>
                </div>
                <button type="submit" className="w-full bg-bluelogo text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 font-gilroy-regular">Create Account</button>
                { !isShopify && !shop_domain &&
                <button type="button" className="w-full bg-white border-2 border-bluelogo font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 font-gilroy-regular mt-4 text-bluelogo" onClick={handleGoogleLogin}>
                    <div className="flex items-center justify-center">
                        <img src="/google.png" alt="Google Logo" className="h-4 w-4 mr-2" />
                        Sign In with Google
                    </div>
                </button>
                }
                <span className="text-red-500 text-xs"> {err}</span>
                </form>


            </div>
            </div>
        </div>
        </>
  );
}

export default CreateAccount;